export const GET_AUTH_TOKEN = 'GET_AUTH_TOKEN';
export const STORE_AUTH_TOKEN = 'STORE_AUTH_TOKEN';
export const IS_AUTH_ADMIN = 'IS_AUTH_ADMIN';
export const SET_AUTH_LOADING = 'SET_AUTH_LOADING';
export const CHECK_IS_ADMIN = 'CHECK_IS_ADMIN';
export const LOGOUT_AUTH = 'LOGOUT_AUTH';

export const getAuthToken = () => ({ type: GET_AUTH_TOKEN });
export const storeAuthToken = (data) => ({ type: STORE_AUTH_TOKEN, data });
export const isAuthAdmin = (data) => ({ type: IS_AUTH_ADMIN, data });
export const setAuthLoading = () => ({ type: SET_AUTH_LOADING });
export const checkIsAdmin = (data) => ({ type: CHECK_IS_ADMIN, data });
export const logoutAuth = () => ({ type: LOGOUT_AUTH });
